import { render, staticRenderFns } from "./SetupWizard.vue?vue&type=template&id=55d2ff56&scoped=true"
import script from "./SetupWizard.vue?vue&type=script&lang=js"
export * from "./SetupWizard.vue?vue&type=script&lang=js"
import style0 from "./SetupWizard.vue?vue&type=style&index=0&id=55d2ff56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d2ff56",
  null
  
)

export default component.exports